import { isAlive, types } from 'mst-effect';

const MAX_PER_PAGE = 128;

interface Fetcher<TFetchedObject> {
  (page: number, perPage: number): Promise<TFetchedObject[]>;
}

/**
 * **WARNING: This type of behavior should be avoided at all costs.
 * Double check with backend, PMs, everyone that this is the only way to achieve what you need.**
 *
 * Gives model an action to fetch all pages of an endpoint until there are no more results.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const withFetchAllPages = () =>
  types.model({}).actions((self) => ({
    /**
     * Continuously fetch all pages until there are no more results.
     */
    async fetchAllPages<TFetchedObject>(fetcher: Fetcher<TFetchedObject>) {
      let page = 1;
      let fetchMore = true;
      const allObjects: TFetchedObject[] = [];

      while (isAlive(self) && fetchMore) {
        // need to await results before fetching again
        // eslint-disable-next-line no-await-in-loop
        const result = await fetcher(page, MAX_PER_PAGE);
        allObjects.push(...result);
        fetchMore = result.length === MAX_PER_PAGE;
        page += 1;
      }

      return allObjects;
    },
  }));
